import { ConfigConta, ConfigModulos, ConfigPsim } from '../core/types';

// Mesmas chaves/encoding dos services Angular (ConfigModulosService,
// ConfiguracoesService, ContaService), para a folha ler o que o React grava e
// vice-versa.
const CONFIG_MODULOS_KEY = 'configModulos';
const CONFIG_CONTA_KEY = 'configuracaoConta';
const MULTICONTA_KEY = 'multiconta';
const PSIM_HABILITADO_KEY = 'psimHabilitado';
const WEBHOOK_HABILITADO_KEY = 'webhookHabilitado';
const SISTEMA_PSIM_KEY = 'sistemaPSIM';

/** Lê sessionStorage['configModulos'] (JSON string); null se ausente/ilegível. */
export function getConfigModulosStorage(): ConfigModulos | null {
  try {
    const raw = sessionStorage.getItem(CONFIG_MODULOS_KEY);
    return raw === null ? null : (JSON.parse(raw) as ConfigModulos);
  } catch {
    return null;
  }
}

/** Grava sessionStorage['configModulos'] como JSON string, igual ao ConfigModulosService. */
export function saveConfigModulosStorage(config: ConfigModulos): void {
  try {
    sessionStorage.setItem(CONFIG_MODULOS_KEY, JSON.stringify(config));
  } catch {
    // Storage indisponível (modo privado, quota, etc.) — best-effort.
  }
}

/** Lê sessionStorage['configuracaoConta'] (JSON string); null se ausente/ilegível. */
export function getConfigContaStorage(): ConfigConta | null {
  try {
    const raw = sessionStorage.getItem(CONFIG_CONTA_KEY);
    return raw === null ? null : (JSON.parse(raw) as ConfigConta);
  } catch {
    return null;
  }
}

/** Grava sessionStorage['configuracaoConta'] como JSON string, igual ao ConfiguracoesService. */
export function saveConfigContaStorage(config: ConfigConta): void {
  try {
    sessionStorage.setItem(CONFIG_CONTA_KEY, JSON.stringify(config));
  } catch {
    // Storage indisponível — best-effort.
  }
}

/**
 * Lê sessionStorage['multiconta'] (JSON bool). Diferente do
 * `ContaService.getMultiContaStorage` (que trata falsy como `false`), aqui a
 * ausência/ilegibilidade retorna `null` para o hook saber que precisa consultar
 * o Endpoint_Multiconta — só um valor booleano decodificado é definitivo.
 */
export function getMulticontaStorage(): boolean | null {
  try {
    const raw = sessionStorage.getItem(MULTICONTA_KEY);
    if (raw === null) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === 'boolean' ? parsed : null;
  } catch {
    return null;
  }
}

/** Grava sessionStorage['multiconta'] como JSON bool, igual ao ContaService. */
export function saveMulticontaStorage(value: boolean): void {
  try {
    sessionStorage.setItem(MULTICONTA_KEY, JSON.stringify(value));
  } catch {
    // Storage indisponível — best-effort.
  }
}

/** sessionStorage['psimHabilitado'] só é verdadeiro na string exata 'true', igual ao MenuRoutes. */
export function getPsimHabilitado(): boolean {
  try {
    return sessionStorage.getItem(PSIM_HABILITADO_KEY) === 'true';
  } catch {
    return false;
  }
}

/** sessionStorage['webhookHabilitado'] só é verdadeiro na string exata 'true', igual ao MenuRoutes. */
export function getWebhookHabilitado(): boolean {
  try {
    return sessionStorage.getItem(WEBHOOK_HABILITADO_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Lê sessionStorage['sistemaPSIM'] (JSON string); null se ausente/ilegível. */
export function getSistemaPsim(): string | null {
  try {
    const raw = sessionStorage.getItem(SISTEMA_PSIM_KEY);
    return raw === null ? null : (JSON.parse(raw) as string);
  } catch {
    return null;
  }
}

/**
 * Grava psimHabilitado/webhookHabilitado/sistemaPSIM com o mesmo encoding dos
 * 3 pontos de escrita Angular (LoginService, AppComponent, ConfigpsimConexaoComponent),
 * para a folha ler o que o React grava.
 */
export function saveConfigPsimStorage(config: ConfigPsim): void {
  try {
    sessionStorage.setItem(PSIM_HABILITADO_KEY, JSON.stringify(config.habilitar));
    sessionStorage.setItem(WEBHOOK_HABILITADO_KEY, JSON.stringify(config.webhookHabilitado));
    sessionStorage.setItem(SISTEMA_PSIM_KEY, JSON.stringify(config.sistemaPSIM));
  } catch {
    // Storage indisponível — best-effort.
  }
}
